import React, { Component } from "react";
import { Container, Header, Message, Segment } from "semantic-ui-react";
import InputAction from "./components/inputs/InputAction";
import "./InputActionDemo.css";

const inputActions = [
  {
    name: "full_name",
    field_type: "Text",
    label: "Text",
    placeholder: "Enter a name",
    comment: "A standard single-line text field.",
  },
  {
    name: "email",
    field_type: "Text",
    label: "Email text",
    placeholder: "name@example.com",
    comment: "Text fields named email use the browser's email input type.",
  },
  {
    name: "password",
    field_type: "Password",
    label: "Password",
    placeholder: "Enter a password",
  },
  {
    name: "quantity",
    field_type: "Number",
    label: "Number",
    placeholder: "Enter a whole number",
    mandatory: true,
  },
  {
    name: "frequency",
    field_type: "Dropdown",
    label: "Dropdown",
    placeholder: "Choose a frequency",
    options: [
      { option_text: "Daily", option_value: "daily" },
      { option_text: "Weekly", option_value: "weekly" },
      { option_text: "Monthly", option_value: "monthly" },
    ],
  },
  {
    name: "notes",
    field_type: "Textarea",
    label: "Textarea",
    placeholder: "Add a longer note",
    rows: 4,
    maxLength: 240,
  },
  {
    name: "audience",
    field_type: "Radio buttons",
    label: "Radio buttons",
    options: [
      { option_text: "Everyone", option_value: "everyone" },
      { option_text: "My team", option_value: "team" },
      { option_text: "Just me", option_value: "private" },
    ],
  },
  {
    name: "send_updates",
    field_type: "Checkbox",
    label: "Checkbox label",
    text_above: "Checkbox",
    comment: "Checkbox values are stored as the strings true or false.",
  },
  {
    name: "start_date",
    field_type: "Date",
    label: "Date",
    comment: "The date control also includes Today and Clear actions.",
  },
];

const initialValues = {
  full_name: "Ada Lovelace",
  email: "ada@example.com",
  password: "analytical-engine",
  quantity: "3",
  frequency: "weekly",
  notes: "InputAction keeps the field contract small and predictable.",
  audience: "team",
  send_updates: "true",
  start_date: "18/07/2026",
};

class InputActionDemo extends Component {
  state = initialValues;

  handleChange = name => value => this.setState({ [name]: value });

  render() {
    return (
      <main className="input-action-demo">
        <Container>
          <div className="input-action-demo__intro">
            <p className="input-action-demo__eyebrow">Component playground</p>
            <Header as="h1">InputAction demo</Header>
            <p className="input-action-demo__lede">
              Every field type supported by the input action component, wired to
              live state.
            </p>
          </div>

          <Message info>
            Change any value below to see the controlled component behavior. The
            value panel reflects the exact strings sent to the change handler.
          </Message>

          <Segment.Group className="input-action-demo__fields">
            {inputActions.map(attributes => (
              <InputAction
                key={attributes.name}
                {...attributes}
                value={this.state[attributes.name] || ""}
                handleChange={this.handleChange(attributes.name)}
              />
            ))}
          </Segment.Group>

          <section className="input-action-demo__values" aria-live="polite">
            <Header as="h2">Current values</Header>
            <pre>{JSON.stringify(this.state, null, 2)}</pre>
          </section>
        </Container>
      </main>
    );
  }
}

export default InputActionDemo;